module.exports = __webpack_public_path__ + "static/media/profileEdit.06cbf263.svg";